import { useContext, useRef, useEffect } from "react";
import { useStyle } from "lib/hooks";
import Input from "../Input";
import ColorPicker from "../ColorPicker";
import Select from "../Select";
import { TreeContext } from "pages/Editor";

/**
 * convert
 * 1px solid #fff -> ['1px', 'solid', '#fff']
 * 1px solid rgba(0, 0, 0) -> ['1px', 'solid', 'rgba(0, 0, 0)']
 *
 * @param {string} border
 * @returns {array}
 */
function splitBorder(border) {
  if (!border) return ["", "", ""];
  const parts = [];
  let idx;
  // first part
  idx = border.indexOf(" ");
  parts.push(border.slice(0, idx));
  border = border.slice(idx + 1);
  // second part
  idx = border.indexOf(" ");
  parts.push(border.slice(0, idx));
  border = border.slice(idx + 1);
  // third part
  parts.push(border);
  return parts;
}

export default function Border() {
  const { selection } = useContext(TreeContext);
  const [border, setStyle] = useStyle("border");
  // <input>
  const width = useRef();
  // colorpicker instance
  const color = useRef();
  // <select>
  const style = useRef();
  const onChange = () => {
    const arr = [
      width.current.value || "1px",
      style.current.value || "solid",
      color.current.color.hexString || "#ccc",
    ];
    if (!arr[0].includes("px")) arr[0] += "px";
    setStyle(arr.join(" "));
  };
  useEffect(() => {
    const b = splitBorder(border);
    width.current.value = b[0];
    style.current.value = b[1];
    if (b[2]) {
      // irojs is very strict about values
      // make sure it doesnt crash the app
      try {
        if (b[2].startsWith("rgb")) {
          color.current.color.rgbString = b[2];
        } else if (b[2].startsWith("#")) {
          color.current.color.hexString = b[2];
        } else {
          console.error("irojs: unknown value", b[2]);
        }
      } catch (e) {
        console.error("irojs: unacceptable value", b[2]);
      }
    } else {
      color.current.el.parentNode.style.background = null;
    }
  }, [selection, border]);
  return (
    <div className="inps">
      <Input ref={width} {...{ onChange }} type="number" placeholder="Width" />
      <ColorPicker ref={color} {...{ onChange }} placeholder="Color" s />
      <Select ref={style} {...{ onChange }} placeholder="Style">
        {["solid", "dotted", "dashed"]}
      </Select>
    </div>
  );
}
